module.exports = __webpack_public_path__ + "static/img_4530-15fa3612f071c3969f0e8dc4e625e0b7.webp";